import { atom } from 'jotai'
import { PaymentsResponse } from 'types/payments'
import { WalletType } from 'types/types'
import { SendStep } from 'types/walletActions'

export const sendStepAtom = atom<SendStep>(SendStep.CONTACT)
export const sendWalletAtom = atom<WalletType>()
export const estimateIdAtom = atom('')
export const paymentAtom = atom<PaymentsResponse>()
